export default "__VITE_ASSET__4bPtwQf3__"